import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-all duration-200 ease-[cubic-bezier(0.33,1,0.68,1)] focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 animate-fade-in",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-accent/10 text-accent hover:bg-accent/20 hover:scale-105",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 hover:scale-105",
        destructive:
          "border-transparent bg-destructive/10 text-destructive hover:bg-destructive/20 hover:scale-105",
        outline: "text-foreground border-border/50 hover:border-border hover:scale-105",
        success:
          "border-transparent bg-accent/10 text-accent dark:bg-accent/20 hover:scale-105",
        warning:
          "border-transparent bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200 hover:scale-105",
        beta:
          "border-transparent bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-200 hover:scale-105",
        info:
          "border-transparent bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200 hover:scale-105",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
